import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Chip, List, ListItem, ListItemText, ListItemIcon, Divider, TextField } from '@mui/material';
import { openComponent, resetIncentiveValue, updateIncentiveValue, updateIsValid } from '../../../../stateManagement/actions/incentiveActions';
import { useSelector } from 'react-redux';
import { IncentiveHeader } from '../incentiveHeader/IncentiveHeader';
import './IncentiveMultiSelect.css'
import { openPopup } from '../../../../stateManagement/actions/popupActions';
import { IncentiveChip } from './IncentiveChip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBroom, faCheck, faCirclePlus } from '@fortawesome/free-solid-svg-icons';

interface ListItem {
    name: string,
    points: number // Use lowercase `number`
}

const IncentiveMultiSelectList = (props: { listOptions: string[], stateName: string, displayPoints?: boolean }) => {
    const storeData = useSelector((state: any) => state?.manageIncentive?.data[props.stateName]);
    const storeValueList = useSelector((state: any) => state?.manageIncentive?.data[props.stateName]?.value);
    const storedDates = useSelector((state: any) => state?.manageIncentive?.data["storedDates"]);

    const [selectedListItem, setSelectedListItem] = useState<ListItem[]>([]);
    const [showList, setShowList] = useState<boolean>(false);
    useEffect(() => {
        console.log("testing", showList, storeData)
    }, [showList])
    // Initialize selected KPIs from Redux store when component mounts or when kpiSelection changes
    useEffect(() => {
        if (storeValueList) {
            setSelectedListItem(storeValueList);
        }else{
            setSelectedListItem([]);
        }

        if (storeData && !(validate() && !showList)) {
            console.log("testing 2", props.stateName, showList, storeData)
            setShowList(true);
        }
    }, [storeValueList]);

    const updateReduxState = (selectedListItem: any) => {
        if (storeData) {
            updateIncentiveValue(selectedListItem, props.stateName); // dispatch to store]
            updateIncentiveValue(null ,"storedDates");
            storedDates.isValid = false;
        }
    }
    // Handle selecting/deselecting a KPI
    const handleToggle = (kpi: string) => {
        const existingKpi = selectedListItem.find(item => item.name === kpi); // Use === for comparison

        if (existingKpi) {
            updateReduxState(selectedListItem.filter(item => item.name !== kpi));
        } else {
            updateReduxState([...selectedListItem, { name: kpi, points: 0 }]);
        }
    };

    // Handle removing a selected KPI from the chip
    const handleRemoveKpi = (kpi: string) => {
        updateReduxState(selectedListItem.filter(item => item.name !== kpi));
    };

    // Clear all selected KPIs
    const handleClear = () => {
        updateReduxState([]);
    };

    useEffect(() => {
        if (storeData) {
            updateIsValid(!showList, props.stateName);
        }
    }, [showList])


    const validate = () => {
        if (!storeValueList) {
            return false;
        }
        if (storeValueList.length == 0) {
            return false
        }
        if (props.displayPoints) {
            let flag = true;
            storeValueList.forEach((kpi: any) => {
                if (kpi.points <= 0) {
                    flag = false;
                }
            })
            return flag;
        }
        return true;
    }

    // Save selected KPIs to store
    const handleSave = () => {
        if (validate()) {
            updateIsValid(true, props.stateName);
            setShowList(false);
            if (storeData.childState) {
                openComponent(storeData.childState);
            }
        } else {
            openPopup("Alert", "This field can not be empty");
        }
    };

    // Handle points change for a specific KPI (with immutability)
    const handlePointsChange = (kpi: string, points: number) => {
        updateReduxState(selectedListItem.map(item =>
            item.name === kpi ? { ...item, points } : item // Create a new object with updated points
        ));
    };

    return (
        <IncentiveHeader heading={storeData?.label} open={storeData?.isOpen} showList={showList} setShowList={setShowList}>
            <div className='incentive-multi-select'>

                {/* Selected KPIs as Chips */}
                <div className='incentive-multi-select-header'>
                    <div className='incentive-multi-select-chips-wrapper'>
                        {selectedListItem.map((kpi) => (
                            <IncentiveChip
                                key={kpi.name}
                                label={props.displayPoints ? `${kpi.name}: ${kpi.points} pts` : `${kpi.name}`}
                                onDelete={() => handleRemoveKpi(kpi.name)}
                            />
                        ))}
                    </div>

                    {/* Action Buttons */}
                    {
                        showList ? <div className='incentive-multi-select-buttons-wrapper'>
                            <Button className='incentive-multi-select-clear' variant="outlined" color="error" onClick={handleClear}>
                                <FontAwesomeIcon
                                    icon={faCirclePlus}
                                />
                                Clear
                            </Button>
                            <Button className='incentive-multi-select-save' variant="contained" color="primary" onClick={handleSave}>
                                <FontAwesomeIcon
                                    icon={faCheck}
                                />
                                Save
                            </Button>
                        </div>
                            : <></>
                    }
                </div>

                {/* List of KPI Options with Checkboxes */}
                {showList ? <div className='incentive-multi-select-list'>
                    {props.listOptions.map((kpi) => {
                        const isPresentInselectedList = selectedListItem.some(item => item.name === kpi);
                        const pointsvalue = selectedListItem.length > 0 ?
                            (selectedListItem.find((e) => e.name === kpi)?.points || 0) : 0;
                        return (
                            <div className={`incentive-list-item ${isPresentInselectedList ? "active" : ""}`} key={kpi} onClick={() => handleToggle(kpi)}>
                                <Checkbox
                                    className='incentive-checkbox'
                                    edge="start"
                                    checked={isPresentInselectedList}
                                    tabIndex={-1}
                                    disableRipple
                                />
                                <div className='incentive-list-item-label'>
                                    {kpi}
                                </div>
                                    {isPresentInselectedList && props.displayPoints ? (
                                        <div  className={`incentive-multi-select-input-field ${pointsvalue === 0 ? 'empty' : ''}`}>
                                            <input
                                                onClick={(event) => event.stopPropagation()}  // Prevent the checkbox toggle
                                                onFocus={(event) => event.stopPropagation()}  // Prevent the checkbox toggle
                                                value={pointsvalue > 0 ? pointsvalue.toString() : "Define Points"}
                                                type="number"
                                                onChange={(event) => handlePointsChange(kpi, Number(event.target.value))}
                                            />
                                            <span>pts</span>
                                        </div>
                                    ) : null}


                            </div>

                        );
                    })}
                </div>
                    : <></>
                }
            </div>
        </IncentiveHeader>
    );
};

export default IncentiveMultiSelectList;
